import { streamsRepository } from '@/repositories/api/streamsRepository'
import { cvProcessRepository } from '@/repositories/api/cvProcessRepository'
import { insertPointRegistrationRepository } from '@/repositories/api/insertPointRegistrationRepository'

const repositories = {
  streams: streamsRepository,
  cvProcess: cvProcessRepository,
  insertPointRegistration: insertPointRegistrationRepository,
}

export const apiRepositoryFactory = {
  get: (key) => repositories[key],
}
